/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClusterHealthCheckOutput } from '../../models/cluster-health-check-output';

export interface GetServersHealth$Params {
  SystemSerialNumber: string;
  SystemMaterialNumber: number;
}

export function getServersHealth(http: HttpClient, rootUrl: string, params: GetServersHealth$Params, context?: HttpContext): Observable<StrictHttpResponse<ClusterHealthCheckOutput>> {
  const rb = new RequestBuilder(rootUrl, getServersHealth.PATH, 'get');
  if (params) {
    rb.path('SystemSerialNumber', params.SystemSerialNumber, {});
    rb.path('SystemMaterialNumber', params.SystemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClusterHealthCheckOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getServersHealth.PATH = '/api/SyngoViaHealthScoring/ServerHealth/{SystemSerialNumber}/{SystemMaterialNumber}';
getServersHealth.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getServersHealth.ROOTURL = '/syngovia';
